import { render } from "./historicalNav.vue?vue&type=template&id=b8878270&scoped=true&ts=true"
import script from "./historicalNav.vue?vue&type=script&lang=ts"
export * from "./historicalNav.vue?vue&type=script&lang=ts"

import "./historicalNav.vue?vue&type=style&index=0&id=b8878270&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8878270"]])

export default __exports__